import {
  PrimaryButtonClassname,
  SecondaryButtonClassname,
  smallSecondaryClass,
} from '@shared/components/buttons';
import { Link, type LinkProps } from '@tanstack/react-router';

// The router-aware twins of the shared buttons. They stay in the app: frontend/shared can't
// depend on @tanstack/react-router (the marketing site has no router).
type ReactLinkButton = React.FC<LinkProps>;

// Link twin of SmallSecondaryButton, for a small affordance that navigates
// rather than acts. Same class string, so the two stay one control in the
// eye even when a row pairs them (Edit + Cancel on an order).
export const SmallSecondaryLinkButton: ReactLinkButton = (properties) => (
  <Link className={smallSecondaryClass} {...properties} />
);

// Shares PrimaryButtonClassname so a link-styled primary action is pixel-identical
// to PrimaryButton — same 40px height, centering, solid-button lift, and focus
// ring. (Previously this diverged and rendered a few px shorter than PrimaryButton.)
export const PrimaryLinkButton: ReactLinkButton = (properties) => (
  <Link className={PrimaryButtonClassname} {...properties} />
);

export const SecondaryLinkButton: ReactLinkButton = (properties) => (
  <Link
    className="flex items-center gap-2 py-2 px-4 bg-white text-gray-900 shadow-toolbar ring-1 ring-inset ring-toolbar-edge rounded-sm hover:bg-gray-50 transition duration-150 disabled:bg-gray-50 disabled:text-gray-400 disabled:ring-gray-300 disabled:shadow-none disabled:cursor-not-allowed cursor-pointer focus:outline-none focus-visible:ring-toolbar-edge-focus"
    {...properties}
  />
);

export const LinkButton: ReactLinkButton = (properties) => (
  <Link className={SecondaryButtonClassname} {...properties} />
);
